<template>
    <div class="deplete_cont">
        <div class="deplete_box">
            <div class="deplete_chose">
                <div class="module">
                    <div class="dropdown" v-for="item in choaselist" :key="item.id"
                        :class="choseid == item.id ? 'chose' : ''">
                        <!-- {{ item }} -->
                        {{ choaselist[0].name }}
                        <!-- {{ item.name }} -->
                        <el-dropdown v-if="item.euqipmentlist.length > 0" @command="handleCommand">
                            <span class="el-dropdown-link">
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="i in item.euqipmentlist" :key="i.id"
                                    :command="beforeHandleCommand(i.id, i.name, i.id)">
                                    {{ i.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="block">
                    <el-date-picker v-model="value1" type="month" placeholder="Select date" format="yyyy - MM"
                        :change="changedate()" value-format="yyyy-MM">
                    </el-date-picker>
                </div>
            </div>
            <div class="depletechart_box">
                <datecharts :rowData="chartData" :toolname="toolname" :unit="dataunit" style="width: 100%; height:100%"
                    v-if="chartData">
                </datecharts>
                <div v-else class="nodata">
                    <div>
                        <img src="../../../assets/1@2x (1).png" alt="">
                        <div>
                            No Relevant Data Available
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import datecharts from "./charts/datecharts.vue";
import commonApi from "@/api/common.js";
// import config from '@/utils/config';;

export default {
    components: {
        datecharts,
    },
    computed: {
        timeDefault() {
            var date = new Date();
            var s1 = date.getFullYear() + "-" + (date.getMonth() + 1);
            return s1;
        }
    },

    data() {
        return {
            choaselist: null,
            value1: null,
            show: true,
            allControlData: null,
            openIndex: null,
            chartData: null,
            bigchartdata: null,
            activeName: null,
            timer: null,
            toolname: null,
            // chartData:
            choaselist: [
                {
                    id: 0,
                    name: 'Daily Consumption',
                    euqipmentlist: [
                    ]
                },
            ],
            dataunit: null,
            choseid: null
        };
    },

    watch: {
        value1(newVal, oldVal) {
            // this.codChart.resize();
            // this.myChart.resize()
            this.getControlData(this.openIndex)

        },
    },
    mounted() {
        this.openIndex = this.$route.query.index;
        this.value1 = this.timeDefault;
        this.getControlData(this.openIndex)
    },
    methods: {
        changedate() {
            console.log(this.value1);

        },

        async getControlData(index) {
            const { data: res } = await this.$http.get("/modules/consume/get", {
                params: { index: index, month: this.value1 },
            });
            this.choaselist = [
                {
                    id: 0,
                    name: 'Daily Consumption',
                    euqipmentlist: [
                    ]
                },
            ]
            this.allControlData = res.data.result;
            for (let a = 0; a < this.allControlData.length; a++) {
                this.choaselist[0].euqipmentlist.push({
                    id: a,
                    name: this.allControlData[a].title
                })
            }
            console.log(this.allControlData);
            let arr = []
            this.dataunit = this.allControlData[0].legend[0].unit

            for (let a = 0; a < this.allControlData[0].xAxis.length; a++) {
                arr.push([
                    this.allControlData[0].xAxis[a], this.allControlData[0].legend[0].yAxis[a]
                ])
            }
            this.toolname = this.allControlData[0].title
            // console.log(this.allControlData[this.choseid]);
            this.chartData = arr
            console.log(this.choaselist);
            // this.handleCommand(command)
        },
        cbrBtnStyle(index) {
            if (this.allControlData.result.pool[index].flag == true) {
                return { backgroundColor: "#1890ff", color: "fff" };
            } else {
                return { backgroundColor: "#b8b8b8", color: "fff" };
            }
        },

        changeChart(item) {
            console.log(item);
            this.bigchartdata = item;
            console.log(item);
        },
        handleClick(tab, event) {
            this.changeChart(this.chartData[tab.index].data[0])
        },

        beforeHandleCommand(index, command, id) {
            console.log(index, command, id);

            return {
                'id': index,
                'command': command,
                'listid': id
            }
        },
        handleCommand(command) {
            console.log(command);
            this.toolname = command.command
            this.choseid = command.listid
            for (var i = 0; i < this.choaselist.length; i++) {
                console.log(123213123);
                // if (this.choaselist[i].id == command.listid) {
                this.choaselist[i].name = command.command
                // }
            }
            let arr = []
            // console.log(this.allControlData[this.choseid]);
            this.dataunit = this.allControlData[this.choseid].legend[0].unit
            console.log(this.dataunit);

            for (let a = 0; a < this.allControlData[this.choseid].xAxis.length; a++) {
                arr.push([
                    this.allControlData[this.choseid].xAxis[a], this.allControlData[this.choseid].legend[0].yAxis[a]
                ])
            }
            this.chartData = arr
            console.log(this.choaselist);
        }
    },
};
</script>

<style lang="scss" scoped>
.deplete_cont {
    .deplete_box {
        left: 1992.9px;
        top: 773.5px;
        width: 466.7px;
        height: 328.9px;
        opacity: 1;
        border-radius: 26px;
        background: #212121FF;
        box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

        .deplete_chose {
            margin-left: 26px;
            margin-right: 26px;
            padding-top: 15px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            // justify-content: center
            .module {
                display: flex;

                .dropdown {
                    margin-right: 17px;
                    font-size: 18.2px;
                    color: rgba(214, 214, 214, 1);
                }

                .chose {
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 21.33px;
                    color: rgba(67, 142, 217, 1);
                    text-align: left;
                    vertical-align: top;
                }
            }
        }
    }

    .depletechart_box {
        // background-color: red;
        height: 260px;
        width: 460px;
        overflow: auto;
        overflow-x: hidden;

        .nodata {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            vertical-align: middle;

            img {
                height: 150px
            }
        }
    }


    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 160px;
    }
}


.depletechart_box::-webkit-scrollbar {
    height: 20px;
    width: 10px;
}


.depletechart_box::-webkit-scrollbar-corner {
    background-color: transparent;
}


.depletechart_box::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(214, 214, 214, 1);
}


.depletechart_box::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: rgba(240, 240, 240, 1);
}

.depletechart_box ::-webkit-scrollbar-button {}
</style>
